import React, { Component } from 'react';
import { Table } from 'react-bootstrap';
import TotalTellingData from './TotalTellingData'
class TotaalTelling extends Component {
    constructor() {
        super();
        this.state = {
            Rows: [],
        }
    }
    render() {
        return (
            <div className="rapport" style={{ display: (this.props.data + this.props.data2 > 0 ? 'block' : 'none') }}>
                <h5><strong>Totaaltelling punten </strong></h5>
                <Table responsive bordered className="totaaltelling">
                    <thead>
                        <tr>
                            <th>&nbsp;</th>
                            <th>eenheden</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr style={{ display: (this.props.data > 0 ? 'table-row' : 'none') }}>
                            <td>Totaaltelling ingevoerde O ee's</td>
                            <td>{this.props.data}</td>
                        </tr>
                        <tr style={{ display: (this.props.data2 > 0 ? 'table-row' : 'none') }}>
                            <td>Totaaltelling ingevoerde CC2b and CC3 ee's</td>
                            <td>{this.props.data2}</td>
                        </tr>

                        {/**<tr>
                            <td>Totaaltelling RTb</td>
                            <td>0.00</td>
                        </tr>**/}
                    </tbody>
                </Table>
            </div>
        );
    }
}

export default TotaalTelling;


// WEBPACK FOOTER //
// ./src/components/Member/Modules/Rapport/TotaalTelling.js